import { useEffect, useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import API from '../../lib/api';
import { Button } from '../../components/ui/button';
import { RecordList } from '../../components/erp/RecordList';
import { ErpHeading } from '../../components/erp/ErpShared';

export default function OrganizationPage() {
  const { permissions } = useOutletContext();
  const [kind, setKind] = useState('company');
  const [parents, setParents] = useState([]);
  useEffect(() => { API.get('/erp/records/unit?page_size=100').then(r => setParents(r.data.items)).catch(() => {}); }, [kind]);
  return <><ErpHeading title="Organizație" /><div className="flex gap-2 flex-wrap mb-8">{[['company', 'Companie'], ['unit', 'Unități'], ['location', 'Locații'], ['setting', 'Setări']].map(([key, label]) => <Button key={key} variant={kind === key ? 'secondary' : 'ghost'} onClick={() => setKind(key)} data-testid={`organization-${key}`}>{label}</Button>)}</div><RecordList key={kind} kind={kind} parents={parents} canWrite={permissions.includes('company.write')} /></>;
}